import { Modal } from 'antd';

export type EntityType = 'project' | 'objection' | 'user' | 'script';

type ConfirmModalProps = {
    open: boolean;
    mode?: 'create' | 'update' | 'acknowledge' | 'copy';
    entityName?: string | null;
    entityType?: EntityType;
    copyTargetName?: string | null;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
    /** Якщо задано разом з confirmMessage — підставляються замість стандартних текстів */
    confirmTitle?: string;
    confirmMessage?: string;
    confirmOkText?: string;
};

const getEntityTypeLabel = (type?: EntityType): string => {
    switch (type) {
        case 'project':
            return 'проект';
        case 'objection':
            return 'заперечення';
        case 'user':
            return 'користувача';
        case 'script':
            return 'скрипт';
        default:
            return 'запис';
    }
};

export const ConfirmModal = ({
    open,
    mode = 'create',
    entityName,
    entityType = 'project',
    copyTargetName,
    onConfirm,
    onCancel,
    loading = false,
    confirmTitle,
    confirmMessage,
    confirmOkText,
}: ConfirmModalProps) => {
    const isUpdate = mode === 'update';
    const isAcknowledge = mode === 'acknowledge';
    const isCopy = mode === 'copy';
    const entityLabel = getEntityTypeLabel(entityType);

    let title: string;
    let okText: string;
    let message: string;

    if (confirmTitle != null && confirmMessage != null) {
        title = confirmTitle;
        message = confirmMessage;
        okText = confirmOkText ?? 'Підтвердити';
    } else if (isAcknowledge) {
        title = 'Підтвердження ознайомлення';
        okText = 'Підтвердити';
        message = 'Ви впевнені, що ознайомились зі змінами?';
    } else if (isCopy) {
        title = 'Підтвердження копіювання';
        okText = 'Копіювати';
        const scriptPart = entityName ? `скрипт "${entityName}"` : `${entityLabel}`;
        const projectPart = copyTargetName ? `проєкт "${copyTargetName}"` : 'обраний проєкт';
        message = `Ви впевнені, що хочете скопіювати ${scriptPart} у ${projectPart}?`;
    } else {
        title = isUpdate ? 'Підтвердження оновлення' : 'Підтвердження створення';
        okText = isUpdate ? 'Оновити' : 'Створити';
        const actionText = isUpdate ? 'оновити' : 'створити';
        message = entityName
            ? `Ви впевнені, що хочете ${actionText} ${entityLabel} "${entityName}"?`
            : `Ви впевнені, що хочете ${actionText} ${entityLabel}?`;
    }

    return (
        <Modal
            title={title}
            open={open}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={okText}
            cancelText="Скасувати"
            confirmLoading={loading}
        >
            <p>{message}</p>
        </Modal>
    );
};
